export const cuisines = [
    { name: "Pizza", emoji: "🍕" },
    { name: "North Indian", emoji: "🍛" },
    { name: "Burgers", emoji: "🍔" },
    { name: "Biryani", emoji: "🍚" },
    { name: "Rolls", emoji: "🌯" },
    { name: "Cakes", emoji: "🍰" },
    { name: "Momos", emoji: "🥟" },
    { name: "Dosa", emoji: "🥞" },
    { name: "Chinese", emoji: "🥡" },
    { name: "Pasta", emoji: "🍝" },
    { name: "Kebabs", emoji: "🍢" },
    { name: "Ice Cream", emoji: "🍨" },
    { name: "Noodles", emoji: "🍜" },
    { name: "Pav Bhaji", emoji: "🥖" },
    { name: "South Indian", emoji: "🥥" },
    { name: "Pure Veg", emoji: "🌿" },
    { name: "Paratha", emoji: "🫓" },
    { name: "Shawarma", emoji: "🧆" },
];
